import React, { useState } from "react";
import { RichTreeView } from "@mui/x-tree-view/RichTreeView";
import { Box } from "@mui/material";
import reportingtreejson from "../Tempdata/ReportingTreejson";
import { useDispatch } from "react-redux";
import { updatereporttreepathselected } from "../store/report_data";

export default function ReportingTreeviewpage() {
  const dispatch = useDispatch();
  const [selecteditemid, setSelecteditemid] = useState("1");

  var path = [];
  const handleitemselected = (event, ids) => {
    path = [];
    setSelecteditemid(ids);
    generateselectedelementpath(ids, reportingtreejson);
    dispatch(updatereporttreepathselected(path.reverse()));
  };
  const generateselectedelementpath = (key, tree) => {
    for (let i = 0; i < tree.length; i++) {
      const node = tree[i];
      if (node.children.length !== 0) {
        if (node.id === key) {
          path.push(node.label);
          return;
        } else {
          generateselectedelementpath(key, node.children);
          if (path.length !== 0) {
            path.push(node.label);
            return;
          }
        }
      } else {
        if (node.id === key) {
          path.push(node.label);
        }
      }
    }
  };

  return (
    <Box
      sx={{
        height: "100%",
        textAlign: "left",
        margin: "10px",
        overflow: "auto",
      }}
    >
      <RichTreeView
        sx={{
          "& MuiTreeItem-group": {
            color: "var(--HighlightedText_Stroke) !important",
            fontWeight: "700 !important",
          },
          "& .Mui-selected:hover": {
            backgroundColor: "transparent !important",
          },
          "& .Mui-selected": {
            backgroundColor: "transparent !important",
            color: "var(--HighlightedText_Stroke) !important",
            fontWeight: "700 !important",
          },
          "& .Mui-focused": {
            backgroundColor: "transparent !important",
            color: "var(--HighlightedText_Stroke) !important",
            fontWeight: "700 !important",
          },
          "& .Mui-selected .MuiTreeItem-content": {
            backgroundColor: "transparent !important",
            color: "var(--HighlightedText_Stroke) !important",
            fontWeight: "700 !important",
          },
          color: "var(--PrimaryText)",
        }}
        items={reportingtreejson}
        onSelectedItemsChange={handleitemselected}
        defaultSelectedItems={"1"}
        selectedItems={selecteditemid}
      />
    </Box>
  );
}
